export default "__VITE_ASSET__DeiW35ZE__"